import { format, parseISO } from "date-fns";
import { useScheduleSessionsContext } from "./use-schedule-sessions-context";

/** The `review` step: every assigned session with its booked slot, before commit. */
export function ReviewStep() {
  const { state } = useScheduleSessionsContext();
  const { sessions, assignments } = state;

  return (
    <div className="flex flex-col overflow-y-auto">
      <div className="flex flex-col gap-2.5 p-5">
        {sessions.map((s) => {
          const a = assignments[s.orderSetId];
          if (!a) return null;
          const start = a.candidate.start;
          const end = a.candidate.end;
          return (
            <div
              key={s.orderSetId}
              className="grid grid-cols-[1fr_auto] items-start gap-4 rounded-lg border bg-muted/40 p-3"
            >
              <div>
                <p className="mb-1 text-sm font-semibold">{s.sessionTitle}</p>
                {s.procedures.map((p) => (
                  <div key={p.id} className="flex items-center gap-1">
                    <span className="h-0.5 w-0.5 shrink-0 rounded-full bg-muted-foreground/40" />
                    <span className="text-xs text-muted-foreground">{p.title}</span>
                  </div>
                ))}
              </div>
              <div className="shrink-0 text-right">
                <p className="text-sm font-semibold">{format(parseISO(start), "EEE, MMM d")}</p>
                <p className="mt-0.5 text-xs text-muted-foreground">
                  {format(parseISO(start), "h:mm a")}
                  {" – "}
                  {format(parseISO(end), "h:mm a")}
                </p>
                {s.duration != null && <p className="text-[10px] text-muted-foreground">{s.duration} min</p>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
